import { useAppStore } from '@src/app/context'

import DeviceAudioUnsupportedError from './DeviceAudioUnsupportedError'

export default function useDeviceAudio() {
  const { service } = useAppStore()

  const audio = service.voice.device?.audio

  if (!audio) {
    throw new DeviceAudioUnsupportedError()
  }

  return audio
}
